import api from '../../../../../common/api.js'
import baseStrategy from './baseStrategy.js'

import {setColumnsToDataMap} from '../../dataImport/index.js'

export default class supplierStrategy extends baseStrategy {
  static title = 'Create Suppliers'
  static requiredColumns = ['company', 'email']

  static getExampleRows() {
    return () =>
      api.get('/supplier/', {limit: 5}).then(({json: data}) => {
        const rows = [
          [
            'Company *Req',
            'Contact Name',
            'Phone',
            'Fax',
            'Email *Req',
            'Street1',
            'Street2',
            'City',
            'State',
            'Zip',
            'Country',
            'Reference Number',
          ],
        ]

        data.supplier.forEach((supplier) => {
          rows.push([
            supplier.address.company,
            supplier.address.name,
            supplier.address.phone,
            supplier.address.fax,
            supplier.address.email,
            supplier.address.street1,
            supplier.address.street2,
            supplier.address.city,
            supplier.address.state,
            supplier.address.zip,
            supplier.address.country,
            supplier.address.reference_number,
          ])
        })

        return rows
      })
  }

  static guessAtColumnDataMap(columns) {
    function find(regex) {
      return columns.findIndex((column) => column.search(regex) !== -1)
    }

    const columnsToDataMap = {
      company: find(/company/i),
      name: find(/contact|name/i),
      phone: find(/phone/i),
      fax: find(/fax/i),
      email: find(/email/i),
      street1: find(/street1/i),
      street2: find(/street2/i),
      city: find(/city/i),
      state: find(/state/i),
      zip: find(/zip/i),
      country: find(/country/i),
      reference_number: find(/reference.number/i),
    }

    return setColumnsToDataMap(columnsToDataMap)
  }

  static transformRowToData(row, columnsByName) {
    const data = this.getNewData()

    data.payload = {
      company: row[columnsByName.company],
      name: row[columnsByName.name],
      phone: row[columnsByName.phone],
      fax: row[columnsByName.fax],
      email: row[columnsByName.email],
      street1: row[columnsByName.street1],
      street2: row[columnsByName.street2],
      city: row[columnsByName.city],
      state: row[columnsByName.state],
      zip: row[columnsByName.zip],
      country: row[columnsByName.country],
      reference_number: row[columnsByName.reference_number],
    }

    data.errors = this.determineDataErrors(data)

    return data
  }

  static determineDataErrors(data) {
    const payload = data.payload
    const errors = {...data.errors}

    this.required(payload, errors, 'company', 'Company is required')
    this.required(payload, errors, 'email', 'Email is required')

    return errors
  }

  static save(data) {
    return () => api.post('/supplier', data.payload)
  }
}
